import { useNavigate } from "flemo";
import { useEffect } from "react";

export function RedirectToHome() {
  const { replace } = useNavigate();

  useEffect(() => {
    void replace("/", {}, { transitionName: "none" });
  }, [replace]);

  return null;
}
